import { Load } from '../../visualisation/load';
import {
  CircleGeometry,
  DoubleSide,
  EdgesGeometry,
  Group,
  LineBasicMaterial,
  LineSegments,
  Mesh,
  MeshBasicMaterial,
} from 'three';

export class RotationTool {
  private readonly meshBlueMaterial: MeshBasicMaterial = new MeshBasicMaterial({
    color: 0x164a71,
    side: DoubleSide,
    depthWrite: true,
  });
  private readonly meshWhiteMaterial: MeshBasicMaterial = new MeshBasicMaterial({
    color: 0xffffff,
    side: DoubleSide,
    depthWrite: true,
  });
  private readonly lineMaterial: LineBasicMaterial = new LineBasicMaterial({
    color: 0x164a71,
    side: DoubleSide,
    transparent: true,
    depthWrite: true,
    opacity: 1,
  });

  public drawRotationTool(object: Load, name = 'rotationToolGroup'): Group {
    const rotationToolGroup = new Group();
    rotationToolGroup.name = name;
    const margin = 1000;
    const smallCircleRadius = 500;
    const smallestCircle = 3000;
    const maxCircleRadius= 6000;
    let circleRadius =
      object.width > object.length ? object.width / 2 - margin : object.length / 2 - margin;
    circleRadius = circleRadius < smallestCircle ? smallestCircle : circleRadius;
    circleRadius = circleRadius > maxCircleRadius ? maxCircleRadius : circleRadius;
    const circleGeometry = new CircleGeometry(circleRadius, 32);

    const circleEdgesGeometry = new EdgesGeometry(circleGeometry);
    const bigCircle = new LineSegments(circleEdgesGeometry, this.lineMaterial);
    rotationToolGroup.add(bigCircle);

    const centralCircleGeometry = new CircleGeometry(smallCircleRadius, 16);
    const centralCircleMesh = new Mesh(centralCircleGeometry, this.meshWhiteMaterial);
    rotationToolGroup.add(centralCircleMesh);

    const centralCircleEdge = new EdgesGeometry(centralCircleGeometry);
    const centralCircleEdges = new LineSegments(centralCircleEdge, this.lineMaterial);
    rotationToolGroup.add(centralCircleEdges);

    const sideCircleGeometry = new CircleGeometry(smallCircleRadius, 16);
    const sideCircleMesh = new Mesh(sideCircleGeometry, this.meshBlueMaterial);
    sideCircleMesh.translateX(-circleRadius);
    sideCircleMesh.translateY(1.55);
    rotationToolGroup.add(sideCircleMesh);

    rotationToolGroup.position.set(
      object.position.x + object.width / 2,
      object.position.y + object.height + 2,
      object.position.z + object.length / 2,
    );
    return rotationToolGroup;
  }
}
